// @ts-nocheck

function getEffectiveCartTotal(bar, format) {
  const taxesIncluded  = bar.dataset.taxesIncluded === 'true';
  const defaultTaxRate = (window.VAT_CONFIG?.taxRate ?? 25) / 100;

  const items = JSON.parse(bar.dataset.cartItems || '[]');

  let exVat = 0, inclVat = 0;
  for (const [price, taxable, tax] of items) {
    if (taxesIncluded) {
      inclVat += price;
      exVat += tax !== null ? price - tax
             : taxable      ? Math.round(price / (1 + defaultTaxRate))
             :                price;
    } else {
      exVat += price;
      inclVat += tax !== null ? price + tax
               : taxable      ? Math.round(price * (1 + defaultTaxRate))
               :                price;
    }
  }

  return format === 'b2c' ? inclVat : exVat;
}

function formatAmount(cents, currency) {
  return new Intl.NumberFormat(document.documentElement.lang || 'sv', {
    style: 'currency',
    currency: currency || 'SEK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Math.round(cents / 100));
}

function updateFreeShippingBar(format) {
  const bar = document.querySelector('[data-free-shipping-bar]');
  if (!bar || !format) return;

  const threshold    = parseInt(bar.dataset[format === 'b2b' ? 'thresholdB2b' : 'thresholdB2c'], 10);
  const effectiveCart = getEffectiveCartTotal(bar, format);
  const remaining    = threshold - effectiveCart;
  const progress     = Math.min(100, Math.max(0, Math.round(effectiveCart * 100 / threshold)));

  const msgEl = bar.querySelector('.cart-free-shipping__message');
  if (msgEl) {
    if (remaining > 0) {
      const amount = formatAmount(remaining, bar.dataset.currency);
      msgEl.innerHTML = bar.dataset.msgRemaining.replace('__AMOUNT__', `<strong>${amount}</strong>`);
    } else {
      msgEl.innerHTML = bar.dataset.msgUnlocked;
    }
  }

  const fill = bar.querySelector('.cart-free-shipping__fill');
  if (fill) {
    fill.style.width = progress + '%';
    fill.classList.toggle('cart-free-shipping__fill--complete', progress >= 100);
  }
  bar.querySelector('.cart-free-shipping__bar')?.setAttribute('aria-valuenow', progress);
}

window.addEventListener('pricing:changed', (e) => { updateFreeShippingBar(e.detail); });
document.addEventListener('cart:finished:updating', () => { updateFreeShippingBar(window.pricingFormat); });
document.addEventListener('section:rendered', () => { updateFreeShippingBar(window.pricingFormat); });

updateFreeShippingBar(window.pricingFormat);

(function () {
  const inner = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
  if (!inner) return;
  const opts = { childList: true, subtree: true, attributes: true, attributeFilter: ['data-cart-items'] };
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => {
      observer.disconnect();
      updateFreeShippingBar(window.pricingFormat);
      observer.observe(inner, opts);
      scheduled = false;
    });
  });
  observer.observe(inner, opts);
}());
